module.exports = __webpack_public_path__ + "static/media/bg0.3544bca8.jpg";